import {
  IconCheckCircle2,
  IconCircleInfo,
  IconCircleX,
  IconExclamationTriangle,
  IconLoadingCircle,
} from "@/lib/icons";
import { useTheme } from "next-themes";
import { Toaster as Sonner, type ToasterProps } from "sonner";

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      icons={{
        success: <IconCheckCircle2 className="size-4" />,
        info: <IconCircleInfo className="size-4" />,
        warning: <IconExclamationTriangle className="size-4" />,
        error: <IconCircleX className="size-4" />,
        loading: <IconLoadingCircle className="size-4 animate-spin" />,
      }}
      style={
        {
          "--normal-bg": "var(--muted)",
          "--normal-text": "var(--foreground)",
          "--normal-border": "var(--border)",
          "--border-radius": "var(--radius)",
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
